import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

function TerminalMouseOver(props) {
  const [stages, setStages] = useState([]);

  let arr =
    props.direction == 1
      ? props.service.boarding_stages.split(',')
      : props.service.dropoff_stages.split(',');

  useEffect(() => {
    if (props.terminals) {
      let tempArr = [];
      for (let i = 0; i < arr.length; i++) {
        let terminal = arr[i].split('||')[1];
        let locationName = props.terminals[arr[i].split('||')[0].split('|')[0]];
        let time = arr[i].split('||')[0].split('|')[1];
        // tempArr.push(`${locationName} ${terminal} ${time}`);
        tempArr.push(`${locationName} ${time}`);
      }
      setStages(tempArr);
    }
  }, [props.terminals]);

  return (
    <div
      className="mouseover-popups terminal-mouseover nowrap font9"
      ref={(el) => {
        props.terminalEl[props.service.id + '1'] = el;
      }}
      // style={{
      //   marginTop:
      //     '-' +
      //     (props.terminalEl[props.service.id + '1']
      //       ? props.terminalEl[props.service.id + '1'].clientHeight / 2
      //       : 0) +
      //     'px',
      // }}
    >
      <style>
        .terminal-mouseover {'{'}
        background-color:{' '}
        {props.operator && props.operator.color_codes && props.operator.color_codes.secondary_color
          ? props.operator.color_codes.secondary_color
          : '#ff5c60'}
        ;{'}'}
        .service-info-row .time-info .primary-triangle {'{'}
        border-right: 19px solid{' '}
        {props.operator && props.operator.color_codes && props.operator.color_codes.secondary_color
          ? props.operator.color_codes.secondary_color
          : '#ff5c60'}
        ;{'}'}
      </style>
      {props.terminals ? (
        stages.map((item) => <div className="bold-text">{item}</div>)
      ) : (
        <div className="bold-text">{props.label}</div>
      )}
      <span className="primary-triangle"></span>
    </div>
  );

  // ========================================================== OLD CODE ==========================================================
  // return (
  //   <div
  //     className="mouseover-popups terminal-mouseover nowrap font9"
  //     ref={el => {
  //       props.terminalEl[props.service.id + '1'] = el;
  //     }}
  //     style={{
  //       marginTop:
  //         '-' +
  //         (props.terminalEl[props.service.id + '1']
  //           ? props.terminalEl[props.service.id + '1'].clientHeight / 2
  //           : 0) +
  //         'px',
  //     }}
  //   >
  //     <div className="bold-text">
  //       {props.direction == 1
  //         ? (props.terminals &&
  //             props.terminals[Number(props.service.boarding_stages.split('|')[0])]) ||
  //           props.label
  //         : (props.terminals &&
  //             props.terminals[Number(props.service.dropoff_stages.split('|')[0])]) ||
  //           props.label}
  //     </div>
  //     <span className="primary-triangle"> </span>
  //   </div>
  // );
}

export default TerminalMouseOver;



// WEBPACK FOOTER //
// ./src/features/pb-service-list/TerminalMouseOver.js